import 'css-chunksrc/client/common/display/styles.scss';export default {
  "display": "_display_8aphf_1",
  "overlay": "_overlay_8aphf_8",
  "content": "_content_8aphf_17",
  "slideInRight": "_slideInRight_8aphf_1",
  "closedContent": "_closedContent_8aphf_28",
  "slideOutRight": "_slideOutRight_8aphf_1"
};